interface Address {
  street: string;
  city: string;
  zipCode: string;
}

export const addressFormatter = (address: Address) => {
  const { street, city, zipCode } = address;

  return `${street ? street : ''}${city ? `, ${city}` : ''}${zipCode ? `, ${zipCode}` : ''}`;
};
